var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    id: "blobSvg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    x: 0,
    y: 0,
    width: 6,
    height: 6,
    patternUnits: "userSpaceOnUse",
    fill: "#d1d8e0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0h1L0 6V5zM6 5v1H5z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "blob",
    d: "M478.5,285Q466,320,403,317.5Q340,315,344.5,350.5Q349,386,324.5,395Q300,404,275,387.5Q250,371,232,365.5Q214,360,201.5,347Q189,334,126,360Q63,386,93,338.5Q123,291,117,270.5Q111,250,102.5,224.5Q94,199,81.5,158.5Q69,118,104.5,108.5Q140,99,176,116.5Q212,134,231,85Q250,36,269.5,83.5Q289,131,334.5,101Q380,71,398.5,99.5Q417,128,399.5,167.5Q382,207,436.5,228.5Q491,250,478.5,285Z",
    fill: "url(#pattern)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.49650f022debfe3cdc71c06c1bbdc08c.svg";
export { ForwardRef as ReactComponent };